import { render, staticRenderFns } from "./safetyInventory.vue?vue&type=template&id=31a25fe4&scoped=true"
import script from "./safetyInventory.vue?vue&type=script&lang=js"
export * from "./safetyInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a25fe4",
  null
  
)

export default component.exports